<template>
    <div class="FilshCourseModalWarp">
        <el-dialog title="" :visible.sync="filishVisible" width="1200px" class="dialogWarp" @closed="offmodalFn" :destroy-on-close="true"
            :close-on-click-modal='false' :append-to-body="true">
            <div class="singupdialogcenter">
                <div class="title">
                    成绩证书查看
                </div>
                <el-table :data="gridData" :header-cell-style="tableHeaderColor">
                    <el-table-column label="序号" type="index" width="50"></el-table-column>
                    <el-table-column v-if="currentCourse.trainType==1||currentCourse.trainType==4" property="userName" label="姓名"  align="center"></el-table-column>
                    <!-- <el-table-column v-else property="names" label="姓名"  align="center"></el-table-column> -->
                     <el-table-column  v-else  label="姓名" align="center">
                        <template slot-scope="scope">
                            <div>{{scope.row.stringMap['姓名']?scope.row.stringMap['姓名']:'-'}}</div>
                        </template>
                    </el-table-column>
                    <el-table-column v-if="currentCourse.trainType==1||currentCourse.trainType==4" property="cardId" label="身份证号码"  align="center"></el-table-column>
                    <!-- <el-table-column  :property="cardCode" label="身份证号码"  align="center"></el-table-column>-->
                     <el-table-column v-else label="身份证号码" align="center">
                        <template slot-scope="scope">
                            <div>{{scope.row.stringMap['身份证']?scope.row.stringMap['身份证']:'-'}}</div>
                        </template>
                    </el-table-column>
                    <!-- <el-table-column property="phone" label="手机号码"  align="center"></el-table-column> -->
                    <el-table-column label="成绩" align="center">
                        <template slot-scope="scope">
                            <span  v-if="scope.row.score" >
                                {{scope.row.score}}
                            </span>
                            <div v-else> - </div>
                        </template>
                    </el-table-column>
                    <el-table-column fixed="right" label="证书" width="120"  align="center">
                        <template slot-scope="scope">
                            <el-button @click="seeRow(scope.row)" type="text" size="small" v-if="scope.row.certificateUrl">
                                查看
                            </el-button>
                            <div v-else> - </div>
                        </template>
                    </el-table-column>
                </el-table>
                <div class="paging_warp">
                    <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page.sync="currentPage" :page-sizes="[10, 15, 20]"
                        :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper" :total="total"></el-pagination>
                </div>
                <div class="formBtnBox">
                    <el-button type="primary" @click="offmodalFn" class="submitBtn">关闭</el-button>
                </div>
            </div>
        </el-dialog>
        <!-- 查看证书 -->
        <CertificateModal :isShow.sync="certificateVisible" v-if="certificateVisible" :currentData='currentData' @certificateShowModal='certificateShowModal'
        />
    </div>
</template>
<script>
import { httpService, srcUrl } from "@/service/httpService";
import CertificateModal from './CertificateModal'
export default {
    props: ['isShow', 'currentCourse'],
    components: {
        CertificateModal,
    },
    data() {
        return {
            filishVisible: true,
            currentPage: 1,
            // 每页显示条数
            pageSize: 10,
            // 总条数
            total: 0,
            gridData: [],
            certificateVisible: false,
            userId: '',
            currentData: null,

        }
    },
    created() {
        // this.currentCourse
        if (JSON.parse(sessionStorage.getItem('userInfo'))) {
            this.userId = JSON.parse(sessionStorage.getItem('userInfo')).userId
        }
    },
    mounted() {
        this.getList()
    },
    methods: {
        async  getList() {
            let params = {
                trainId: this.currentCourse.trainId,
                pageSize: this.pageSize,
                pageCurrent: this.currentPage
            }
            let data
            if (this.currentCourse.trainType == 0) {
                // 普通课程
                data = await httpService.selectGraduationStudent(params);
            } else if(this.currentCourse.trainType == 1){
                // 领军人才
                data = await httpService.LeadGraduationStudent(params);
            }else{
                data = await httpService.GooseLeadGraduationStudent(params); 
            }
            // let data = await httpService.selectGraduationStudent(params);
            let newList=[]
            if (data.code == 200) {
                // console.log(data.result,'data.result.list');
                
                if (this.currentCourse.trainType == 0) {
                    this.gridData = data.result.pageInfo.list
                    this.total = data.result.pageInfo.total
                }else{
                    this.gridData = data.result.list
                     this.total = data.result.total
                }
                console.log(this.gridData,'this.gridData');
                
            }

        },
        // 分页
        async handleSizeChange(val) {
            this.pageSize = val;
            this.getList()
        },
        async handleCurrentChange(val) {
            this.currentPage = val;
            this.getList()
        },
        tableHeaderColor() {
            return "background-color:#FAFAFA;color:rgba(0,0,0,0.85);border-bottom:2px solid #0083FF;border-top:2px solid #0083FF;font-weight:900;height:55px;color:#A6A9B7";
        },
        seeRow(row) {
            this.currentData = row;
            this.certificateVisible = true;
        },
        // 关闭表单
        offmodalFn() {
            this.$emit('update:isShow', false)
            // this.$emit('filishShowModal', false)
            if (!this.isCustom) this.$destroy() // 销毁当前组件
        },
        // certificateShowModal
        certificateShowModal() {

        }
    }
}
</script>
<style lang="less" scoped>
.dialogWarp {
	/deep/.singupdialogcenter {
		padding: 17px 60px 0px 60px;
		box-sizing: border-box;
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-content: center;
		align-items: center;
		.title {
			font-size: 22px;
			line-height: 54px;
			color: #43424b;
		}
		.textbox {
			font-size: 16px;
			line-height: 30px;
			color: #666666;
			margin-bottom: 120px;
		}
		.paging_warp {
			margin-top: 40px;
		}

		.formBtnBox {
			display: flex;
			fill-opacity: row;
			justify-content: center;
			cursor: pointer;
			margin-top: 60px;
			.submitBtn {
				width: 152px;
				height: 40px;
				background: #349cff;
				margin: 0 20px;
				cursor: pointer;
			}
		}
	}
}
</style>


